export const styles = {
  page: { padding: "60px 0", background: "#fff",marginTop:"12vh" },
  headerArea: { textAlign: "center", marginBottom: "40px" },
  pageTitle: { fontSize: "42px", fontWeight: "800", color: "#1e293b" },
  iconBox: {
    width: "50px",
    height: "50px",
    borderRadius: "15px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "24px",
  },
  itemTitle: {
    fontSize: "18px",
    fontWeight: "800",
    margin: "15px 0 8px 0",
    color: "#1e293b",
  },
  cardDescText: { color: "#64748b", fontSize: "14px", lineHeight: "1.5" },

  fullModalOverlay: {
    position: "fixed",
    inset: 0,
    zIndex: 9999,
    backgroundColor: "#fff",
    overflow: "hidden",
  },

  fullModalContent: { display: "flex", width: "100vw", height: "100vh" },

  leftPanel: {
    width: "35%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    position: "relative",
  },

  leftContent: { textAlign: "center", padding: "20px" },

  heroIconBox: { fontSize: "70px", marginBottom: "15px" },
  heroTitleLarge: { fontSize: "28px", fontWeight: "800" },

  heroSubtitle: {
    fontSize: "15px",
    opacity: 0.8,
    marginBottom: "25px",
  },

  backBtn: {
    padding: "12px 24px",
    background: "#fff",
    border: "none",
    color: "#000",
    borderRadius: "12px",
    cursor: "pointer",
    fontWeight: "800",
  },

  rightPanel: {
    width: "65%",
    background: "#fff",
    padding: "40px 8%",
    overflowY: "auto",
  },

  breadcrumb: {
    fontSize: "12px",
    color: "#94a3b8",
    marginBottom: "10px",
    fontWeight: "600",
  },

  flowTitle: {
    fontSize: "28px",
    fontWeight: "800",
    marginBottom: "40px",
    color: "#1e293b",
  },

  timelineWrapper: { position: "relative", paddingLeft: "40px" },

  timelineBaseLine: {
    position: "absolute",
    left: "15px",
    top: "0",
    bottom: "0",
    width: "3px",
    background: "#fff",
  },

  timelineFillLine: {
    position: "absolute",
    left: "15px",
    top: "0",
    width: "3px",
    transition: "height 0.3s",
  },

  zestyTraveler: {
    position: "absolute",
    left: "-30px",
    transition: "top 0.3s",
  },

  zestyImg: { width: "80px" },

  flowItem: {
    position: "relative",
    marginBottom: "35px",
    display: "flex",
  },

  flowNumber: {
    position: "absolute",
    left: "-45px",
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    border: "3px solid #fff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontWeight: "800",
    zIndex: 5,
  },

  flowCard: {
    flex: 1,
    background: "#f8fafc",
    padding: "20px",
    borderRadius: "20px",
    transition: "0.2s",
  },

  cardTag: {
    fontSize: "10px",
    fontWeight: "800",
    padding: "4px 10px",
    borderRadius: "6px",
    marginBottom: "8px",
    display: "inline-block",
  },

  cardTitle: {
    fontSize: "17px",
    fontWeight: "800",
    marginBottom: "6px",
    color: "#1e293b",
  },

  cardText: { fontSize: "13px", color: "#64748b" },

  exploreMore: {
    fontSize: "12px",
    marginTop: "10px",
    fontWeight: "800",
  },

  finalActionArea: {
    textAlign: "center",
    padding: "40px 0 100px",
  },

  finalGetStartedBtn: {
    padding: "16px 40px",
    color: "#fff",
    borderRadius: "15px",
    fontSize: "16px",
    fontWeight: "800",
    border: "none",
    cursor: "pointer",
  },

  loaderCenter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
  },
};